<template>
    <form  class="form-horizontal" @submit.prevent="submit()">
        <div class="form-group">
            <label for="title" class="col-sm-2 control-label">Titulo</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.title"><br> 
            </div>
            
        </div>
        <div class="form-group">
            <label for="title" class="col-sm-2 control-label">Descripción</label>
            <div class="col-sm-10">
                 <el-switch  v-model="data.active_desc"   on-text="SI" off-text="NO"></el-switch> <br>
            </div>  
            <div class="col-sm-offset-2 col-sm-10">
                <editor id="description" v-model="description" ></editor><br> 
            </div>   
        </div>
        <div class="form-group">
            <label for="title" class="col-sm-2 control-label">Recomendación</label>
            <div class="col-sm-10">
                 <el-switch  v-model="data.active_rec"   on-text="SI" off-text="NO"></el-switch> <br>
            </div>   
            <div class="col-sm-offset-2 col-sm-10">
                <editor id="recommendation" v-model="recommendation"></editor><br>
            </div>  
        </div>
        <div class="form-group">
            <label for="title" class="col-sm-2 control-label">Footer Búsqueda</label>
            <div class="col-sm-10">
                 <el-switch  v-model="data.active_footer"    on-text="SI" off-text="NO"></el-switch> <br>
            </div>   
            <div class="col-sm-offset-2 col-sm-10">
                <editor id="footer" v-model="footer"></editor><br>
            </div>  
        </div>
        <div class="form-group">
            <label for="title" class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10 ">
                <div class=" preview">
                    <div class="row">
                        <br>
                        <div  class="container">
                            <div class="col-md-8">
                                <br>
                                Servicio de información entregado por <a href="">Instituto de Previsión Social</a>
                                <h2 >{{data.title}}</h2>
                                <br>
                            </div>
                        </div>
                    </div>  
                    <div class="row">
                        <div class="container">
                            <div class="col-md-8">
                                <span v-if="data.active_desc"  v-html="description"></span>
                                <br><br>
                                <div v-if="data.active_rec"  class="alert alert-info" role="alert">
                                    <span v-html="recommendation"></span>
                                </div>
                                 
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="container">
                            <div class="col-md-8 ">
                                <div v-if="consult.id === 1" class="row-full">
                                    <div class="form-group email-pagos">
                                        <label for="run">Ingresa el RUN del beneficiario</label>
                                        <input type="text" maxlength="12" class="input-lg form-control"   placeholder="11.111.111-1" >
                                    </div>
                                    <button type="submit" class="btn btn-lg btn-consultar"><u>Consultar</u></button>
                                </div>
                                <div  v-if="consult.id === 2" class="row-full">
                                    <div class="row form-group  col-xs-12 col-sm-9">
                                        <label for="run">Ingresa RUN que quieres consultar *</label>
                                        <input type="text" maxlength="12" class="input-lg form-control"     placeholder="11.111.111-1" >
                                    </div>

                                    <div class="row form-group  ">
                                        <label class="col-xs-12" for="run">Fecha de nacimiento *</label>
                                        <div class="col-xs-4 col-sm-3">
                                            <select class="form-control" style="border-radius:0px"   name="dia">
                                                <option value="" disabled>Día</option>
                                                <!-- <option v-for="n in 31" :key="n" >{{n}}</option> -->
                                            </select>
                                        </div>
                                        <div class="col col-xs-4 col-sm-3">
                                        <select class="form-control" style="border-radius:0px"   name="mes">
                                            <option value="" disabled selected>Mes</option>
                                            <!-- <option v-for="n in 12" :key="n" >{{n}}</option> -->
                                        </select>
                                        </div>
                                        <div class="col col-xs-4 col-sm-3">
                                        <select class="form-control" style="border-radius:0px"    name="anyo">
                                            <option value="" disabled selected>Año</option>
                                            <!-- <option v-for="n in anyos" :key="n" >{{n}}</option> -->
                                        </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-5">
                                        <label  >* Campos Obligatorios </label>
                                        </div>
                                        <div class="col-xs-12 col-sm-4">
                                        <button type="submit" class="btn btn-lg btn-consultar"  >Consultar</button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="container">
                            <div class="col-md-8 ">
                                <span v-if="data.active_footer" v-html="footer"></span>
                                 <br><br>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
            </div>
        </div>
         <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/mantenedor-consulta-benecificio">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style  scoped>
    .email-pagos{
        display: inline-block;
        width: 70%;
        margin-right: 11px;
        margin-left: 12px;
    }
    .row-full{
        background: #f7f7f7;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-bottom: 30px;
        margin-left: 70px;
        margin-left: 0px;
        padding-left: 15px;
    }
    .preview{
        border: 1px dotted #20a0ff;
    }
    .preview .container{
        width: 1040px;
    }
</style>
<script>
import ElementUI from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';
import { Message } from "element-ui";
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import Editor from './Editor.vue';


export default {

    data:function(){
        const consult = _.cloneDeep(this.consult);

        return{
            data : consult,
            description : consult.description, 
            recommendation :consult.recommendation,
            footer : consult.footer
        }
    },
    watch:{
        description:function(d){
            if(d.length === 0){
                this.data.active_desc = false;
                this.data.description = '';
            }
            else
                this.data.description = d;
        },
        recommendation: function(r){
            if(r.length === 0) {
                this.data.active_rec = false;
                this.data.recommendation = '';
            }
            else
                this.data.recommendation = r;
             
        },
        footer: function(f){
           
            if(f.length=== 0){
                this.data.active_footer = false;
                this.data.footer = '';
            }
            else
                this.data.footer = f;
        }
    },
    props:['consult'],
    components:{
        ElSwitch,
        ElSelect,
        ElOption,
        Editor
    },
    methods:{
        submit:function(){
            var self = this;

            axios({
                url:"backend/mantenedor-consulta-benecificio",
                method:"PUT",
                data: this.data
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }
    }
}
</script>
